import React from "react"
import { scaleLinear } from "d3-scale"
import { area, curveBasis } from "d3-shape"
import { useSpring, animated as a } from "react-spring"

const Wave = ({ topColor, bottomColor }) => {
  const height = 200,
    width = 600

  const heights1 = [0, 5, 20, 60, 20, 80, 20, 70, 10, 90, 20, 80, 20, 5, 0]
  const heights2 = [0, 5, 80, 10, 50, 20, 80, 20, 50, 10, 30, 10, 20, 5, 0]
  const xPoints = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]

  const xScale = scaleLinear()
    .domain([Math.min(...xPoints), Math.max(...xPoints)])
    .range([0, width])

  const yTop = scaleLinear()
    .domain([0, 100])
    .range([height / 2, 0])

  const areaTop = area()
    .x((d) => xScale(d.x))
    .y0(yTop(0))
    .y1((d) => yTop(d.y))
    .curve(curveBasis)

  const yBottom = scaleLinear()
    .domain([0, 100])
    .range([height / 2, height])

  const areaBottom = area()
    .x((d) => xScale(d.x))
    .y0(yBottom(0))
    .y1((d) => yBottom(d.y))
    .curve(curveBasis)

  const [spring, _] = useSpring(() => ({
    from: { data: heights1 },
    to: { data: heights2 },
    loop: { reverse: true },
    config: {
      duration: 400,
    },
  }))

  const getD = (valueArr, type) => {
    const waveData = valueArr.map((val, i) => ({
      x: xPoints[i],
      y: val,
    }))
    return type === "top" ? areaTop(waveData) : areaBottom(waveData)
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0, 0, ${width}, ${height}`}
      preserveAspectRatio="xMidYMid meet">
      <a.path d={spring.data.to((...d) => getD(d, "top"))} fill={topColor} />
      <a.path
        d={spring.data.to((...d) => getD(d, "bottom"))}
        fill={bottomColor}
      />
    </svg>
  )
}

export default Wave
